import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import Image from "next/image";
import React from "react";
import applicationSuccessIcon from "@/assets/applicationSuccessIcon.svg";
import { Button } from "@/components/ui/button";
import { DrawerClose } from "@/components/ui/drawer";
import Link from "next/link";

export interface SuccessDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  setOpen,
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        showCloseIcon={false}
        className="py-[60px] px-11 flex flex-col items-center justify-center gap-8"
      >
        <Image
          src={applicationSuccessIcon.src}
          alt="applicationSuccessIcon"
          width={104}
          height={104}
        />
        <h3 className="text-[#033D61] font-archivo text-4xl font-bold leading-12 text-center">
          Request submitted!
        </h3>
        <p className="text-[#033D61] font-merriweather text-center text-lg font-normal leading-7">
          Thanks you for your request. We will let you the update soon.
        </p>
        <DrawerClose asChild>
          <Link href={"/"}>
            <Button className="xl:px-5 xl:py-3 px-4 py-2.5 h-12 cursor-pointer font-archivo text-base font-medium! leading-6 rounded-[40px] bg-[linear-gradient(264deg,#0798F2_-29%,#43D9BD_85.45%)] hover:bg-[linear-gradient(264deg,#43D9BD_-29%,#0798F2_85.45%)] text-[#033D61]">
              Go Back to Home
            </Button>
          </Link>
        </DrawerClose>
      </DialogContent>
    </Dialog>
  );
};
